/**
 * OPTIMIZED COLLECTION TEMPLATE - Performance Version
 *
 * This version eliminates the 300K+ lines inline script problem by:
 * - Using .js endpoint instead of inline script data
 * - Loading inventory data dynamically only when needed
 * - Reconstructing variant_ids arrays for image compatibility
 *
 * Original backup: collection-template-original-with-logs.js
 */

// Cache for products and variant availability
const productCache = {};
const variantAvailabilityCache = {};
let globalVariantsAvailability = null;
let variantAvailabilityMap = null;

// NEW CODE - Initialization without inline script
document.addEventListener('DOMContentLoaded', function () {
    // Initialize empty map - will be filled dynamically via API
    globalVariantsAvailability = [];
    variantAvailabilityMap = new Map();
});

// Store queryID globally so it's available when adding to cart
let lastQueryID = null;

// Function to keep queryID updated
function updateLastQueryID() {
    if (algoliaShopify && algoliaShopify.instantsearch && algoliaShopify.instantsearch.search && algoliaShopify.instantsearch.search.helper) {
        const helper = algoliaShopify.instantsearch.search.helper;
        if (helper.lastResults && helper.lastResults.queryID) {
            lastQueryID = helper.lastResults.queryID;
        }
    }
}

// Update queryID when search results change
document.addEventListener('algolia.instantsearch.updated', function () {
    updateLastQueryID();
});

// Initially update queryID when page loads
document.addEventListener('DOMContentLoaded', function () {
    // Try to get queryID once page is loaded
    setTimeout(updateLastQueryID, 50);
});

/**
 * Main product card component
 */
class ProductCard extends HTMLElement {
    constructor() {
        super();
        this.productData = null;
        this.viewType = 'grid';
        this.variantsData = null;
        this.colorSwatchSlider = null;
    }

    static get observedAttributes() {
        return ['view-type', 'product-data'];
    }

    connectedCallback() {
        // Initialize when connected to DOM
        if (this.hasAttribute('product-data')) {
            try {
                this.productData = JSON.parse(this.getAttribute('product-data'));
                this.viewType = this.getAttribute('view-type') || 'grid';
                this.render();
                this.loadProductVariants();

                if (window.yotpo) {
                    window.yotpo.refreshWidgets();
                }
            } catch (error) {
                console.error('Error parsing product data:', error);
            }
        }

        // Apply classes to parent container
        const parentListItem = this.closest('.ais-Hits-list');

        if (!parentListItem.classList.contains('product-loop')) {
            parentListItem.classList.add('product-loop');
            const viewType = localStorage.getItem('viewType') || 'grid';

            if (viewType === 'grid') {
                parentListItem.classList.add('grid_wrapper');
            } else {
                parentListItem.classList.add('list-wrapper');
            }
        }

        const parentItem = this.closest('.ais-Hits-item');
        if (parentItem && !parentItem.classList.contains('product-index')) {
            parentItem.classList.remove('ais-Hits-item');
            parentItem.classList.add('product-index', 'span-4', 'md-span-4', 'sm-span-6', 'auto');

            if (this.viewType === "list") {
                parentItem.classList.add('usf-list');
            }
        }
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue === newValue) return;

        if (name === 'view-type') {
            this.viewType = newValue;
            this.updateViewType();
        } else if (name === 'product-data' && newValue) {
            try {
                this.productData = JSON.parse(newValue);
                this.render();
                this.loadProductVariants();
            } catch (error) {
                console.error('Error parsing product data:', error);
            }
        }
    }

    updateViewType() {
        const gridTemplate = this.querySelector('.grid-template');
        const listTemplate = this.querySelector('.list-template');

        if (gridTemplate && listTemplate) {
            gridTemplate.style.display = this.viewType === 'list' ? 'none' : 'flex';
            listTemplate.style.display = this.viewType === 'grid' ? 'none' : 'block';
        }
    }

    async loadProductVariants() {
        if (!this.productData || !this.productData.handle) return;

        try {
            // Check cache first
            // if (!productCache[this.productData.handle]) {
            productCache[this.productData.handle] = await this.fetchProductVariants(this.productData.handle);
            // }

            this.variantsData = productCache[this.productData.handle];

            // Initialize components once we have the data
            this.initializeSwatches();
            this.initializeSizeOptions();
            this.initializeAddToCart();

        } catch (error) {
            console.error('Error loading product variants:', error);
        }
    }

    // NEW METHOD - Uses .js endpoint and updates availability map
    async fetchProductVariants(handle) {
        // Contador global de llamadas
        if (!window.fetchProductVariantsCount) {
            window.fetchProductVariantsCount = 0;
        }
        window.fetchProductVariantsCount++;

        const callNumber = window.fetchProductVariantsCount;

        try {
            const startTime = performance.now();

            // CAMBIO: Usar .js en lugar de .json para obtener datos de inventario
            const response = await fetch(`/products/${handle}.js`);
            const data = await response.json();
            const endTime = performance.now();

            // Build images directly from variant featured_image objects
            const imagesMap = new Map();
            const images = [];

            if (data.variants) {
                data.variants.forEach((variant, index) => {

                    if (variant.featured_image && variant.featured_image.id) {
                        // Si ya tenemos esta imagen, no la agregamos de nuevo
                        if (!imagesMap.has(variant.featured_image.id)) {
                            const imageData = {
                                id: variant.featured_image.id,
                                src: variant.featured_image.src,
                                alt: variant.featured_image.alt,
                                width: variant.featured_image.width,
                                height: variant.featured_image.height,
                                position: variant.featured_image.position,
                                variant_ids: variant.featured_image.variant_ids || []
                            };

                            imagesMap.set(variant.featured_image.id, imageData);
                            images.push(imageData);

                        }
                    } else {
                        console.warn(`❌ Variant ${variant.id} has no featured_image or featured_image.id:`, {
                            variant: variant,
                            hasFeaturedImage: !!variant.featured_image,
                            featuredImageId: variant.featured_image?.id
                        });
                    }
                });
            }

            // If no images but there's an images array, use it as fallback
            if (images.length === 0 && data.images) {
                data.images.forEach((url, index) => {
                    images.push({
                        id: index,
                        src: url.startsWith('//') ? `https:${url}` : url,
                        position: index + 1,
                        alt: null,
                        width: null,
                        height: null,
                        variant_ids: []
                    });
                });
            }

            const result = {
                variants: data.variants || [],
                images: images,
                options: data.options || []
            };

            // ACTUALIZAR EL MAPA DE DISPONIBILIDAD con los datos del API
            if (data.variants && variantAvailabilityMap) {
                data.variants.forEach(variant => {
                    const inventoryData = {
                        id: data.id,
                        variant_id: variant.id,
                        available: variant.available || false,
                        inventory_quantity: 0, // Not available in .js endpoint
                        inventory_policy: 'deny', // Default conservador
                        inventory_management: variant.inventory_management || 'shopify'
                    };

                    // Actualizar el mapa global con los datos de disponibilidad
                    variantAvailabilityMap.set(variant.id.toString(), inventoryData);
                });
            }

            return result;

        } catch (error) {
            console.error(`❌ fetchProductVariants #${callNumber} - Error:`, {
                handle: handle,
                error: error.message,
                totalCalls: callNumber
            });

            // Return empty structure in case of error
            return {
                variants: [],
                images: [],
                options: []
            };
        }
    }

    initializeSwatches() {
        if (!this.variantsData || !this.variantsData.variants.length) {
            return;
        }

        // Group variants by color
        const groupedVariants = this.groupVariantsByColor(this.variantsData.variants);
        const colors = Object.keys(groupedVariants);

        // Get the swatches container
        const swatchContainer = this.querySelector('.usf-is-color');
        if (!swatchContainer) {
            return;
        }

        // Helper function to find the first available variant for a color
        const findFirstAvailableVariant = (colorVariants) => {
            const availableVariant = colorVariants.find(variant =>
                this.isVariantAvailable(variant.id.toString())
            );
            return availableVariant || colorVariants[0];
        };

        // Generate HTML for each color
        let firstAvailableFound = false;

        const swatchHTML = colors.map((color, index) => {
            // Get the first available variant for this color
            const colorVariant = findFirstAvailableVariant(groupedVariants[color]);

            // Check availability once and store result
            const isColorAvailable = this.isVariantAvailable(colorVariant.id.toString());

            // Only the first available color should be selected
            const shouldBeSelected = isColorAvailable && !firstAvailableFound;
            if (shouldBeSelected) {
                firstAvailableFound = true;
            }

            const image = this.variantsData.images.find(img => img.variant_ids?.includes(colorVariant.id));

            return `
            <li data-index="${index}" 
                image="${image?.src || ''}" 
                color="${color}" 
                class="${shouldBeSelected ? 'usf-selected' : ''} ${isColorAvailable ? '' : 'unavailable'}">
                <label for="color-${this.productData.id}"
                  style="${image ? `background-image: url(${image.src});` : ''}"
                  title="${color}">
                </label>
            </li>
        `;
        }).join('');

        swatchContainer.innerHTML = swatchHTML;

        // Assign events to color selectors
        const colorOptions = swatchContainer.querySelectorAll('li');
        colorOptions.forEach((option, index) => {
            option.addEventListener('click', (e) => {
                this.handleColorSelection(e, colors[index], groupedVariants);
            });
        });

        // Initialize slider if there's more than one color
        this.initColorSwatchesSlider();
    }

    initColorSwatchesSlider() {
        const swatchContainer = this.querySelector('.usf-is-color');
        if (!swatchContainer || swatchContainer.classList.contains('tns-slider-initialized')) return;

        const swatchItems = swatchContainer.children;
        if (!swatchItems || swatchItems.length <= 1) return;

        try {
            this.colorSwatchSlider = tns({
                container: swatchContainer,
                items: 3,
                loop: false,
                nav: false,
                mouseDrag: true,
                controlsText: [
                    "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'><path d='M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z'/></svg>",
                    "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'><path d='M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z'/></svg>"
                ],
                responsive: {
                    768: { items: 4 },
                    1200: { items: 5 },
                    1440: { items: 5 },
                    1600: { items: 6 }
                }
            });

            swatchContainer.classList.add('tns-slider-initialized');
        } catch (error) {
            // console.warn('Error initializing slider:', error);
        }
    }

    handleColorSelection(e, selectedColor, groupedVariants) {
        // Update product image
        const imageUrl = e.currentTarget.getAttribute('image');
        const imageContainer = this.querySelector('.ci img');
        if (imageUrl && imageContainer) {
            imageContainer.src = imageUrl;
        }

        // Update active state
        e.currentTarget.parentElement.querySelectorAll('li').forEach(li => {
            li.classList.remove('usf-selected');
        });
        e.currentTarget.classList.add('usf-selected');

        // Render sizes for the selected color
        this.renderSizeOptions(groupedVariants[selectedColor]);
    }

    initializeSizeOptions() {
        if (!this.variantsData || !this.variantsData.variants.length) return;

        // Group variants by color
        const groupedVariants = this.groupVariantsByColor(this.variantsData.variants);

        // Get the currently selected color
        const getSelectedColor = () => {
            const selectedColorElement = this.querySelector('.usf-is-color .usf-selected');
            if (selectedColorElement) {
                return selectedColorElement.getAttribute('color');
            }

            // Fallback: first color in the list
            return Object.keys(groupedVariants)[0];
        };

        const selectedColor = getSelectedColor();
        if (selectedColor && groupedVariants[selectedColor]) {
            this.renderSizeOptions(groupedVariants[selectedColor]);
        }
    }

    renderSizeOptions(variants) {
        if (!variants || !variants.length) return;

        const optionContainer = this.querySelector('.data-option');
        if (!optionContainer) return;

        // Get unique sizes for this color
        const availableSizes = [...new Set(variants.map(v => v.option1))];
        let firstAvailableFound = false;

        optionContainer.innerHTML = availableSizes.map((sizeValue, index) => {
            const variant = variants.find(v => v.option1 === sizeValue);
            if (!variant) return '';

            const isAvailable = this.isVariantAvailable(variant.id.toString());

            // Only the first available size should be selected
            const shouldBeSelected = isAvailable && !firstAvailableFound;
            if (shouldBeSelected) {
                firstAvailableFound = true;
            }

            return `
            <li data-index="${index}" 
                class="${shouldBeSelected ? 'usf-selected' : ''} ${isAvailable ? '' : 'unavailable'}"
                variant-id="${variant.id}" 
                size="${sizeValue}"
                style="${!isAvailable ? 'pointer-events: none;' : ''}">
                <label for="size-${index}">${sizeValue}</label>
            </li>
        `;
        }).join('');

        // Assign events to size options
        this.assignSizeEvents();

        // Estado inicial: los colores deben reflejar ya la talla preseleccionada,
        // no la disponibilidad global del color.
        const preselected = optionContainer.querySelector('li.usf-selected');
        if (preselected) {
            this.refreshColorAvailability(preselected.getAttribute('size'));
        }

        // Update form with the first available variant or fallback to first variant
        const firstAvailableVariant = variants.find(v => this.checkVariantAvailability(v.id)) || variants[0];
        if (firstAvailableVariant) {
            this.updateAddToCartForm(firstAvailableVariant.id);
        }
    }

    assignSizeEvents() {
        const sizeOptions = this.querySelectorAll('.data-option li');

        sizeOptions.forEach(option => {
            option.addEventListener('click', (e) => {
                const variantId = option.getAttribute('variant-id');

                // Update form
                this.updateAddToCartForm(variantId);

                // Update active state
                sizeOptions.forEach(opt => opt.classList.remove('usf-selected'));
                option.classList.add('usf-selected');

                // La disponibilidad de un color es relativa a la talla elegida:
                // al cambiar de talla hay que remarcar los colores sin stock en ella.
                this.refreshColorAvailability(option.getAttribute('size'));
            });
        });
    }

    /**
     * Marca como agotados los colores que no tienen stock en la talla dada.
     * Mismo criterio que el PDP, donde `set_availability` (theme.js) cruza cada
     * swatch contra la opción seleccionada en cada `variantchange`.
     *
     * @param {string} sizeValue - talla seleccionada (option1)
     */
    refreshColorAvailability(sizeValue) {
        if (!sizeValue || !this.variantsData || !this.variantsData.variants) return;

        this.querySelectorAll('.usf-is-color li').forEach(li => {
            const color = li.getAttribute('color');
            if (!color) return;

            // ¿existe esta combinación color + talla, y está disponible?
            const variant = this.variantsData.variants.find(
                v => v.option2 === color && v.option1 === sizeValue
            );
            const isAvailable = variant
                ? this.isVariantAvailable(variant.id.toString())
                : false;

            li.classList.toggle('unavailable', !isAvailable);
        });
    }

    initializeAddToCart() {
        if (!this.variantsData || !this.variantsData.variants.length) return;

        // Get the currently selected variant based on color and size selections
        const getSelectedVariant = () => {
            // Get selected color
            const selectedColorElement = this.querySelector('.usf-is-color .usf-selected');
            const selectedColor = selectedColorElement ? selectedColorElement.getAttribute('color') : null;

            // Get selected size  
            const selectedSizeElement = this.querySelector('.data-option .usf-selected');
            const selectedSize = selectedSizeElement ? selectedSizeElement.getAttribute('size') : null;

            // If we have both color and size selected, find the matching variant
            if (selectedColor && selectedSize) {
                const matchingVariant = this.variantsData.variants.find(variant =>
                    variant.option2 === selectedColor && variant.option1 === selectedSize
                );
                if (matchingVariant) {
                    return matchingVariant;
                }
            }

            // If we only have color selected, get the first available variant for that color
            if (selectedColor) {
                const colorVariants = this.variantsData.variants.filter(variant => variant.option2 === selectedColor);
                const availableColorVariant = colorVariants.find(variant => this.isVariantAvailable(variant.id.toString()));
                if (availableColorVariant) {
                    return availableColorVariant;
                }
            }

            // Fallback: get the first available variant overall
            const firstAvailableVariant = this.variantsData.variants.find(variant =>
                this.isVariantAvailable(variant.id.toString())
            );

            return firstAvailableVariant || this.variantsData.variants[0];
        };

        const initialVariant = getSelectedVariant();

        // For the grid view
        const container = this.querySelector('.add-to-cart-container');
        if (container) {
            const isAvailable = this.productData.can_order && this.checkVariantAvailability(initialVariant.id);

            container.innerHTML = `
            <form method="post" 
                  action="/cart/add" 
                  id="product_form_${this.productData.id}" 
                  accept-charset="UTF-8" 
                  enctype="multipart/form-data"
                  form-id="${this.productData.id}"
                  class="shopify-product-form">

            <input type="hidden" name="id" data-sku value="${initialVariant.id}" />
            <input type="hidden" name="qty" value="1">

            <div class="product-add">
                <input id="AddToCart" 
                    type="submit" 
                    name="button" 
                    class="add clearfix AddtoCart js-ajax-submit" 
                    value="${isAvailable ? 'Add to cart' : 'Sold out'}" 
                    ${!isAvailable ? 'disabled="disabled"' : ''}
                />
            </div>
            </form>
        `;
        }

        // For the list view - update the existing form if it exists
        const listForm = this.querySelector('.list-view-form');
        if (listForm) {
            const listVariantInput = listForm.querySelector('input[name="id"]');
            const listButton = listForm.querySelector('.js-ajax-submit');

            if (listVariantInput) {
                listVariantInput.value = initialVariant.id;
            }

            if (listButton) {
                const isAvailable = this.productData.can_order && this.checkVariantAvailability(initialVariant.id);
                listButton.value = isAvailable ? 'Add to cart' : 'Sold out';
                listButton.disabled = !isAvailable;
            }

            this.setupAjaxCart(listForm);
        }

        // Configure AJAX cart for grid view
        const gridForm = this.querySelector('.shopify-product-form');
        if (gridForm) {
            this.setupAjaxCart(gridForm);
        }
    }

    setupAjaxCart(form) {
        if (!form) return;

        form.addEventListener('submit', (e) => {
            e.preventDefault();

            const formData = new FormData(form);
            const cartConfig = this.getCartConfig();

            // Implementation of trackSearchAttribution similar to original template
            // Obtenemos los datos necesarios de los atributos del elemento padre
            const productCard = this.closest('product-card') || this;
            const queryID = productCard.getAttribute('data-algolia-queryid');
            const objectID = productCard.getAttribute('data-algolia-objectid');
            const index = productCard.getAttribute('data-algolia-index') || 'shopify_productsproducts';
            const position = productCard.getAttribute('data-algolia-position');

            // Solo llamamos a trackSearchAttribution si tenemos queryID y objectID
            if (queryID && objectID && window.algoliaTrackSearchAttribution) {
                window.algoliaTrackSearchAttribution(this.productData);
            }

            // Show loading indicator
            const submitButton = form.querySelector('input[type="submit"]');
            const originalText = submitButton.value;
            submitButton.value = 'Adding...';
            submitButton.disabled = true;

            // Add to cart
            fetch('/cart/add.js', {
                method: 'POST',
                body: formData
            })
                .then(response => response.json())
                .then(data => {
                    // Update the cart
                    try {
                        // Find and update the cart counter in the DOM
                        fetch('/cart.js')
                            .then(response => response.json())
                            .then(cart => {
                                const cartCountElements = document.querySelectorAll('.cart-count');
                                if (cartCountElements.length > 0) {
                                    cartCountElements.forEach(el => {
                                        el.textContent = cart.item_count;
                                        el.classList.remove('hidden');
                                    });
                                }
                            })
                            .catch(err => console.error('Error updating cart count:', err));
                    } catch (error) {
                        console.warn('Could not update cart count:', error);
                    }

                    // Show success message
                    submitButton.value = 'Added!';

                    // Restore original text after a delay
                    setTimeout(() => {
                        submitButton.value = 'Add to cart';
                        submitButton.disabled = false;
                    }, 50);

                    // Open the cart if configured to do so
                    if (cartConfig.openDrawerOnAdd) {
                        // Here would be the code to open the cart
                        // This depends on the specific theme implementation
                    }
                })
                .catch(error => {
                    console.error('Error adding to cart:', error);
                    submitButton.value = 'Error';

                    // Restore original text after a delay
                    setTimeout(() => {
                        submitButton.value = 'Add to cart';
                        submitButton.disabled = false;
                    }, 50);
                });
        });
    }

    updateAddToCartForm(variantId) {
        const form = this.querySelector(`form[form-id="${this.productData.id}"]`);
        const input = form?.querySelector('input[name="id"]');

        if (input) {
            input.value = variantId;

            // Update button state based on availability
            const button = form.querySelector('.js-ajax-submit');
            if (button) {
                const isAvailable = this.checkVariantAvailability(variantId);
                button.disabled = !isAvailable;
                button.value = isAvailable ? 'Add to cart' : 'Sold out';
            }
        }
    }

    getCartConfig() {
        const configElement = document.getElementById('cart-config');
        if (!configElement) {
            console.error('Cart config not found');
            return {};
        }

        try {
            return JSON.parse(configElement.textContent || '{}');
        } catch (error) {
            console.error('Error parsing cart config:', error);
            return {};
        }
    }

    checkVariantAvailability(variantId) {
        variantId = variantId.toString();

        if (!variantAvailabilityCache[variantId]) {
            variantAvailabilityCache[variantId] = this.isVariantAvailable(variantId);
        }

        return variantAvailabilityCache[variantId];
    }

    isVariantAvailable(variantId) {

        // Ensure the Map is initialized
        if (variantAvailabilityMap === null || variantAvailabilityMap.size === 0) {
            // If no data, it's because fetchProductVariants hasn't been called yet
            // Return false conservatively
            console.warn(`OPTIMIZED: No availability data for variant ${variantId} - fetchProductVariants may not have been called yet (dynamic loading)`);
            return false;
        }

        // Instant O(1) lookup
        const variantInfo = variantAvailabilityMap.get(variantId.toString());

        if (!variantInfo) {
            return false;
        }

        return variantInfo.available === true ||
            (variantInfo.inventory_quantity > 0 && variantInfo.inventory_management !== null);
    }

    // NEW METHOD - Simplified
    getVariantsAvailability() {
        // This method is kept for compatibility
        return globalVariantsAvailability || [];
    }

    groupVariantsByColor(variants) {
        return variants.reduce((acc, variant) => {
            const color = variant.option2;
            if (!acc[color]) acc[color] = [];
            acc[color].push(variant);
            return acc;
        }, {});
    }

    render() {
        if (!this.productData) return;

        // Create an html template literal tag function that simulates Algolia's
        const html = (strings, ...values) => String.raw({ raw: strings }, ...values);

        // Create necessary Algolia components
        const components = {
            Highlight: ({ hit, attribute }) => {
                return this.productData._highlightResult && this.productData._highlightResult[attribute]
                    ? this.productData._highlightResult[attribute].value
                    : this.productData[attribute];
            }
        };

        const gridTemplate = this.createProductTemplate(html, components);
        const listTemplate = this.createListTemplate(html, components);

        this.innerHTML = `
            <div class="grid-template" style="${this.viewType === 'list' ? 'display: none;' : ''}">${gridTemplate}</div>
            <div class="list-template" style="${this.viewType === 'grid' ? 'display: none;' : ''}">${listTemplate}</div>
        `;

        // Agregar atributos de datos necesarios para el trackSearchAttribution
        if (this.productData.queryID) {
            this.setAttribute('data-algolia-queryid', this.productData.queryID);
        }
        if (this.productData.objectID) {
            this.setAttribute('data-algolia-objectid', this.productData.objectID);
        }
        if (this.productData.index) {
            this.setAttribute('data-algolia-index', this.productData.index);
        }
        if (this.productData.productPosition) {
            this.setAttribute('data-algolia-position', this.productData.productPosition);
        }
    }

    createProductTemplate(html, components) {
        const hit = this.productData;
        const isOnSale = hit.compare_at_price > hit.price;
        const discount = isOnSale ?
            algoliaShopify.helpers.displayDiscount(hit.price, hit.compare_at_price, hit.price_ratio).replace('-', '') : '';

        return html`
            <div class="ci" data-product-id="${hit.id}" data-variant-id="${hit.objectID}">
                ${isOnSale ? html`
                    <div class="sale-item icn sale-item--percentage">
                        <span class="icn__inner">Save ${discount}</span>
                    </div>` : html``}
                
                <div class="prod-image image_square">
                    <a href="${algoliaShopify.helpers.instantsearchLink(hit)}" title="">
                        <div class="reveal">
                            <div class="box-ratio" style="padding-bottom: 166.667%;">
                                <img src="${hit.image}" alt="${hit.title} - ${hit.variant_title}" loading="lazy" />
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            
            <div class="product-details">
                <a href="${algoliaShopify.helpers.instantsearchLink(hit)}" class="js-product-details-link">
                    <h3 class="mb0">
                        ${components.Highlight({ attribute: 'title', hit })}
                    </h3>
                </a>
                
                <div class="price price--listing ${isOnSale ? 'price--on-sale' : ''}">
                    ${this.renderPrice(hit, isOnSale, html)}
                    <div class="price__badges">
                        <span class="price__badge price__badge--sold-out"><span>Sold Out</span></span>
                    </div>
                </div>

                <div class="yotpo-widget-instance" 
                    data-yotpo-instance-id="458662" 
                    data-yotpo-product-id="${hit.id}" 
                    data-yotpo-cart-product-id="${hit.id}">
                </div>
                
                <div class="usf-swatchs">
                    <ul data-option-index="0" class="data-option" data-option="${hit.id}"></ul>
                    <div class="tns-outer" id="tns1-ow">
                        <ul class="usf-is-color usf-swatch-circle"
                            variant-container="${hit.id}"
                            product-id="${hit.objectID}"
                            data-option-index="0"
                            data-swatch-index="0">
                        </ul>
                    </div>
                </div>
                
                <div class="add-to-cart-container" data-product-id="${hit.id}"></div>
            </div>
        `;
    }

    createListTemplate(html, components) {
        const hit = this.productData;
        const secondImage = hit.images_info && hit.images_info[1] ? hit.images_info[1].src : '';
        const mainImage = hit.image;
        const price = algoliaShopify.helpers.displayPrice(hit, hit.price);
        const isOnSale = hit.compare_at_price > hit.price;
        const isAvailable = this.productData.can_order && this.variantsData && this.variantsData.variants && this.variantsData.variants.length > 0
            ? this.checkVariantAvailability(this.variantsData.variants[0].id)
            : false;

        return html`
            <div class="usf-sr-product list-view-product">
                <div class="list-view-product__content">
                    <div class="usf-img-column">
                        <a href="/products/${hit.handle}" data-usf-pid="${hit.id}">
                            <div class="usf-img-wrapper usf-sr-product__image-container ${secondImage ? 'usf-has-second-img' : ''}">
                                <div data-bgset="${mainImage}" class="usf-main-img lazyload" style="background-image: url('${mainImage}');"></div>
                                <span class="usf-img-loader"></span>
                                ${secondImage ? html`
                                    <div data-bgset="${secondImage}" class="usf-second-img lazyload" 
                                        style="background-image: url('${secondImage}');"></div>
                                    <span class="usf-img-loader"></span>
                                ` : ''}
                            </div>
                        </a>
                    </div>
                    <div class="usf-info-column">
                        <a href="/products/${hit.handle}" data-usf-pid="${hit.id}">
                            <div class="usf-title">${hit.title}</div>
                            ${hit.vendor ? html`<div class="usf-vendor">${hit.vendor}</div>` : ''}
                            <div class="usf-price-wrapper">
                                <span class="usf-price ${isOnSale ? 'usf-price--on-sale' : ''}">${price}</span>
                                ${isOnSale ? html`<span class="usf-price--compare">${algoliaShopify.helpers.displayStrikedPrice(hit.price, hit.compare_at_price)}</span>` : ''}
                            </div>
                            ${hit.description ? html`<div class="usf-description">${hit.description}</div>` : ''}
                        </a>
                        
                        <div class="usf-swatchs list-view-swatches">
                            <ul data-option-index="0" class="data-option" data-option="${hit.id}"></ul>
                            <div class="tns-outer" id="tns1-ow">
                                <ul class="usf-is-color usf-swatch-circle"
                                    variant-container="${hit.id}"
                                    product-id="${hit.objectID}"
                                    data-option-index="0"
                                    data-swatch-index="0">
                                </ul>
                            </div>
                        </div>
                        
                        <div class="list-view-cart-column">
                            <form method="post" 
                                action="/cart/add" 
                                id="product_form_list_${hit.id}" 
                                accept-charset="UTF-8" 
                                enctype="multipart/form-data"
                                form-id="${hit.id}"
                                class="shopify-product-form list-view-form">
                                
                                <input type="hidden" name="id" data-sku value="${this.variantsData && this.variantsData.variants && this.variantsData.variants.length > 0 ? this.variantsData.variants[0].id : ''}" />
                                <input type="hidden" name="qty" value="1">
                                
                                <div class="product-add">
                                    <input 
                                        type="submit" 
                                        name="button" 
                                        class="add clearfix AddtoCart js-ajax-submit list-view-add-to-cart" 
                                        value="${isAvailable ? 'Add to cart' : 'Sold out'}" 
                                        ${!isAvailable ? 'disabled="disabled"' : ''}
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    renderPrice(hit, isOnSale, html) {
        if (!isOnSale) {
            return html`
                <dl class="price__regular">
                    <dt><span class="visually-hidden visually-hidden--inline">Regular</span></dt>
                    <dd><span class="price-item price-item--regular">${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}</span></dd>
                </dl>
            `;
        }

        return html`
            <dl class="price__sale">
                <dt><span class="visually-hidden visually-hidden--inline">Sale</span></dt>
                <dd><span class="price-item price-item--sale">${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}</span></dd>
                <dt><span class="visually-hidden visually-hidden--inline">Regular</span></dt>
                <dd><s class="price-item price-item--regular">${algoliaShopify.helpers.displayStrikedPrice(hit.price, hit.compare_at_price)}</s></dd>
            </dl>
        `;
    }

    async handleAddToCart(e) {
        e.preventDefault();
        const button = e.currentTarget;

        // Validate variant
        const form = button.closest('form');
        const variantInput = form?.querySelector('input[name="id"]');
        const variantId = variantInput?.value;

        if (!variantId) {
            console.error('Variant ID is missing');
            return false;
        }

        // Check availability
        const isAvailable = await this.checkVariantAvailability(variantId);
        if (!isAvailable) {
            alert('This variant is no longer available. Please select another option.');
            button.value = 'Sold out';
            button.disabled = true;
            return false;
        }

        // Set button state
        button.disabled = true;
        button.value = 'Adding...';
        button.classList.add('adding');

        try {
            // Track Algolia conversion if queryID is available and we have the objectID
            const productID = this.productData ? this.productData.objectID : null;

            if (lastQueryID && productID) {
                // Use Algolia's native method for conversion tracking with queryID
                if (algoliaShopify && algoliaShopify.analytics && typeof algoliaShopify.analytics.conversion === 'function') {
                    algoliaShopify.analytics.conversion({
                        objectID: productID,
                        queryID: lastQueryID,
                        eventName: 'Add To Cart',
                        index: 'shopify_productsproducts',
                        userToken: algoliaShopify.shopify_customer_id || 'anonymous'
                    });
                }
            }

            // Configure cart
            const config = this.getCartConfig();
            if (config.cart_action === 'drawer') {
                WAU.Slideout?.init("ajax-cart");
            } else if (config.cart_action === 'modal_cart') {
                WAU.Modal?.init("ajax-cart");
            }

            // Add to cart
            const isQuickAdd = button.hasAttribute('data-quick-add');
            await Shopify.theme.ajaxCart.addToCart(form, button.parentNode, config, false, isQuickAdd);

            // Success
            button.value = 'Added!';
            setTimeout(() => this.resetAddToCartButton(button), 50);

        } catch (error) {
            console.error('Error adding to cart:', error);
            this.resetAddToCartButton(button);
            alert('There was an error adding the product to your cart. Please try again.');
        }

        return false;
    }

    resetAddToCartButton(button) {
        if (!button) return;

        button.disabled = false;
        button.value = 'Add to cart';
        button.classList.remove('adding');
    }
}

/**
 * View type controller component (grid/list)
 * This component listens for events from the original Algolia buttons
 */
class ViewTypeController extends HTMLElement {
    constructor() {
        super();
        this.viewType = localStorage.getItem('viewType') || 'grid';
    }

    connectedCallback() {
        // We don't render anything, just listen to Algolia buttons
        this.findAndAttachToAlgoliaButtons();
        this.updateViewType(); // Apply the saved view initially
    }

    findAndAttachToAlgoliaButtons() {
        // Find the Algolia buttons and attach listeners
        const checkInterval = setInterval(() => {
            const gridButton = document.querySelector('.ais-change-display-block');
            const listButton = document.querySelector('.ais-change-display-list');

            if (gridButton && listButton) {
                clearInterval(checkInterval);

                // Remove existing listeners to avoid duplicates
                gridButton.removeEventListener('click', this.handleGridClick);
                listButton.removeEventListener('click', this.handleListClick);

                // Create bound handler functions for this instance
                this.handleGridClick = () => this.setViewType('grid');
                this.handleListClick = () => this.setViewType('list');

                // Add listeners
                gridButton.addEventListener('click', this.handleGridClick);
                listButton.addEventListener('click', this.handleListClick);

                // Update active classes based on current viewType
                if (this.viewType === 'grid') {
                    gridButton.classList.add('active');
                    listButton.classList.remove('active');
                } else {
                    listButton.classList.add('active');
                    gridButton.classList.remove('active');
                }
            }
        }, 25);

        // Clear the interval after a reasonable time
        setTimeout(() => clearInterval(checkInterval), 50);
    }

    disconnectedCallback() {
        // Clean up event listeners when component disconnects
        const gridButton = document.querySelector('.ais-change-display-block');
        const listButton = document.querySelector('.ais-change-display-list');

        if (gridButton && this.handleGridClick) {
            gridButton.removeEventListener('click', this.handleGridClick);
        }

        if (listButton && this.handleListClick) {
            listButton.removeEventListener('click', this.handleListClick);
        }
    }

    setViewType(type) {
        this.viewType = type;
        localStorage.setItem('viewType', type);

        // Update active classes on Algolia buttons
        const gridButton = document.querySelector('.ais-change-display-block');
        const listButton = document.querySelector('.ais-change-display-list');

        if (gridButton && listButton) {
            if (type === 'grid') {
                gridButton.classList.add('active');
                listButton.classList.remove('active');
            } else {
                listButton.classList.add('active');
                gridButton.classList.remove('active');
            }
        }

        this.updateViewType();
    }

    updateViewType() {
        // Update all product cards
        document.querySelectorAll('product-card').forEach(card => {
            card.setAttribute('view-type', this.viewType);
        });

        // Update container classes
        const itemsContainer = document.querySelector('.ais-Hits-list');
        if (itemsContainer) {
            itemsContainer.classList.remove('grid_wrapper', 'product-loop', 'list-view-items', 'usf-results', 'usf-clear', 'usf-list');

            if (this.viewType == 'grid') {
                itemsContainer.classList.add('grid_wrapper', 'product-loop');
            } else {
                itemsContainer.classList.add('list-view-items', 'usf-results', 'usf-clear', 'usf-list');
            }
        }
    }
}

// Register components
customElements.define('product-card', ProductCard);
customElements.define('view-type-controller', ViewTypeController);

// Algolia initialization
document.addEventListener('algolia.hooks.initialize', function () {
    // Store trackSearchAttribution function globally
    window.algoliaTrackSearchAttribution = null;

    // Configure search options
    algoliaShopify.hooks.registerHook('beforeInstantSearchOptions', function (options) {
        options.hitsPerPage = 12;

        // Tomar filtros existentes (ej: collection_ids:"..." AND inventory_quantity > 0)
        let existing = options.filters || '';

        // El problema: cuando estamos en /collections/all queda algo como " AND inventory_quantity > 0"
        // Limpiamos cualquier AND/OR inicial huérfano.
        existing = existing.replace(/^\s*(AND|OR)\s+/i, '').trim();

        // Construimos lista sin duplicar condiciones
        const parts = [];
        const hasAvailable = /\bavailable:true\b/.test(existing);
        const hasPublished = /\bstatus:published\b/.test(existing);
        if (!hasAvailable) parts.push('available:true');
        if (!hasPublished) parts.push('status:published');
        if (existing) parts.push(existing); // preservar collection_ids, inventory_quantity > 0, etc.

        options.filters = parts.join(' AND ');
        return options;
    });

    // Render products using custom component
    algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function (_defaultTemplate, hit, html, components, trackSearchAttribution) {
        // Store the trackSearchAttribution function globally
        window.algoliaTrackSearchAttribution = trackSearchAttribution;

        return html`
            <product-card product-data='${JSON.stringify(hit)}' view-type="${localStorage.getItem('viewType') || 'grid'}" data-algolia-index="${hit.index}"
            data-algolia-position="${hit.productPosition}"
            data-algolia-queryid="${hit.queryID}"
            data-algolia-objectid="${hit.objectID}"
            data-handle="${hit.handle}"
            data-variant-id="${hit.objectID}"
            data-distinct="${hit._distinct}"
            data-product-id="${hit.id}"
            onClick="${() => trackSearchAttribution(hit)}"></product-card>
        `;
    });

    // Initialize view controller after Algolia has finished rendering
    algoliaShopify.hooks.registerHook('afterISStartRemoveDefaultWidget', function () {
        // Remove unwanted elements
        const searchBoxH1 = document.querySelectorAll('.shopify-app-block h1.ais-h2');
        searchBoxH1.forEach(item => item.remove());

        // Insert view controller if it doesn't exist
        if (!document.querySelector('view-type-controller')) {
            const viewController = document.createElement('view-type-controller');
            document.body.appendChild(viewController);
            viewController.updateViewType();
        }

        // Update product classes
        const itemsProducts = document.querySelectorAll('.ais-Hits-list li.ais-Hits-item');
        itemsProducts.forEach(product => {
            if (!product.classList.contains('product-index')) {
                // product.classList.remove('ais-Hits-item');
                const viewType = localStorage.getItem('viewType') || 'grid';
                product.classList.add('product-index', 'span-4', 'md-span-4', 'sm-span-6', 'auto', `${viewType == "list" ? "usf-list" : ""}`);
            }
        });
    });
});